var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "x-layout",
    { staticClass: "field-group" },
    [
      _c("x-flex", { staticClass: "field-group__left" }, [
        _c("h3", { staticClass: "field-group__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "x-flex",
        { staticClass: "field-group__content" },
        [_c("x-layout", [_vm._t("default")], 2)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }